import React, { useCallback } from 'react';
import { Flex, Pane, Text } from '@leverege/ui-elements';
import { Config } from '@leverege/plugin';
import { Toolbar } from '@leverege/ui-plugin';
import classnames from 'classnames';
import I18N from '@leverege/i18n';
import S from './ErrorView.css';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const ns = 'molten.dataViewers.views.ErrorView';
const {
  t: staticT,
  tIcon: staticTIcon,
  exists: staticExists
} = I18N.ns(ns);
const getKeys = (key, err) => {
  if (err?.status) {
    return [`${key}${err.status}`, key];
  }
  return [key];
};
export default function ErrorView(props) {
  const {
    relationship: {
      blueprint,
      attribute,
      path
    },
    objectType,
    client = 'TableDataViewer',
    errorTitleKey = 'errorTitle',
    errorBodyKey = 'errorBody',
    errorIconKey = 'error',
    errorDocLinkKey = 'errorDocLink',
    error,
    t = staticT,
    tIcon = staticTIcon,
    exists = staticExists
  } = props;
  const resolveTranslation = useCallback((key, dVal, isIcon, cxt) => {
    if (Array.isArray(key)) {
      for (let i = 0; i < key.length; i++) {
        const toReturn = resolveTranslation(key[i], null, isIcon, cxt);
        if (toReturn) {
          return toReturn;
        }
      }
      return dVal;
    }
    const getFunc = isIcon ? 'getIcon' : 'getString';
    const toTranslate = isIcon ? tIcon : t;
    return attribute?.[getFunc]?.(key, null, cxt) || blueprint?.[getFunc]?.(key, null, cxt) || (exists(key) ? toTranslate(key, null, cxt) : null) || dVal;
  }, [attribute, blueprint, t, tIcon]);
  const errorTitle = resolveTranslation(getKeys(errorTitleKey, error), blueprint?.name, false, {
    ...error
  });
  const errorBody = resolveTranslation(getKeys(errorBodyKey, error), t('errorBody', {
    ...error
  }), false, {
    ...error
  });
  const errorIcon = resolveTranslation(getKeys(errorIconKey, error), Config.get('ErrorView', 'errorIcon', tIcon('errorIcon', 'https://molten-ui-assets.storage.googleapis.com/no-data.svg')), true, {
    ...error
  });
  const docLink = resolveTranslation(getKeys(errorDocLinkKey, error), Config.get('ErrorView', 'errorDocLink'), false, {
    ...error
  });
  const errorDimensions = Config.get('ErrorView', 'iconDimensions', {
    height: 224,
    width: 224
  });
  return /*#__PURE__*/_jsxs(Pane, {
    variant: "noDataView",
    className: classnames(S.win, S.errorContainer),
    layout: "flex:rowL",
    children: [/*#__PURE__*/_jsx("img", {
      alt: t('error'),
      src: errorIcon,
      height: errorDimensions.height,
      width: errorDimensions.width
    }), /*#__PURE__*/_jsx(Pane, {
      variant: "noDataBody",
      children: /*#__PURE__*/_jsxs(Flex, {
        variant: "colXL",
        justify: "center",
        vFill: true,
        children: [/*#__PURE__*/_jsxs(Pane, {
          variant: "noDataContent",
          layout: "flex:colL",
          children: [/*#__PURE__*/_jsx(Text, {
            variant: "sectionTitle",
            children: errorTitle
          }), /*#__PURE__*/_jsx(Text, {
            variant: "sectionBody",
            children: errorBody
          }), docLink ? /*#__PURE__*/_jsx("a", {
            style: {
              textDecoration: 'none'
            },
            target: "blank",
            href: docLink,
            children: /*#__PURE__*/_jsx(Text, {
              variant: "link",
              children: t('documentation')
            })
          }) : null]
        }), /*#__PURE__*/_jsx(Toolbar, {
          matchContext: {
            client,
            use: 'error',
            objectType,
            path
          },
          context: {
            clientProps: props
          },
          hasContextMenu: false,
          prefer: "text",
          variant: "noData"
        })]
      })
    })]
  });
}